import React from "react";
import {Typography} from "@material-ui/core";
import lang from "../../lib/appfuse-react/core/lang";
import i18n from "../../lib/appfuse-react/core/i18n";

function TypographyWithLink(props) {
    const {data=[]} = props;

    const result = data.map((source, index) => {
        if(lang.isString(source)) return i18n.translate(source);
        else if(lang.isObject(source)) {
            const {text, param, onClick, style={}} = source;
            const typographyStyle = onClick? {display:'inline' ,textDecoration:'underline' , textUnderlinePosition:'under', cursor:'pointer', ...style}:{...style};
            const color = source.color || 'primary';
            return (
                <Typography key={index} {...source} color={color} style={typographyStyle} >
                    {i18n.translate(text, param)}
                </Typography>
            );
        }
        return '';
    });

    return (<Typography {...props}>{result}</Typography>);
}

export default TypographyWithLink;